// extracted by mini-css-extract-plugin
export var alt = "Col-module--alt--f4fe1";
export var col = "Col-module--col--9c6e0";
export var col10 = "Col-module--col10--2b80c";
export var col2 = "Col-module--col2--40373";
export var col3 = "Col-module--col3--c66ea";
export var col4 = "Col-module--col4--e9728";
export var col5 = "Col-module--col5--26e29";
export var col6 = "Col-module--col6--8ec5c";
export var col7 = "Col-module--col7--2efed";
export var col8 = "Col-module--col8--51808";
export var col9 = "Col-module--col9--4503e";
export var colBase = "Col-module--colBase--b7a6c";
export var colBase1 = "Col-module--colBase1--d78d6";
export var desktopOnly = "Col-module--desktopOnly--e8283";
export var main = "Col-module--main--09448";
export var mobileOnly = "Col-module--mobileOnly--0b1d0";
export var textLeft = "Col-module--textLeft--d9d0b";
export var visuallyHidden = "Col-module--visuallyHidden--686b9";